const getLoaderState = (state) => state.auth.loading;

const getUser = (state) => state.auth.user;

const getAccountType = (state) => state.auth.accountType;

const getActiveDevice = (state) => {
  const devices = Array.isArray(state.auth.devices)
    ? state.auth.devices.slice()
    : [];
  const activeDevice = devices.find((item) => item.selected);
  return activeDevice;
};

const getAllDevices = (state) => state.auth.devices;

const getAllNotifications = (state) => state.auth.notifications;
const getWeather = (state) => state.auth.weather;

const selectors = {
  getLoaderState,
  getUser,
  getActiveDevice,
  getAllDevices,
  getAllNotifications,
  getAccountType,
  getWeather,
};

export default selectors;
